import React from "react";

const ReadTab = () => {
    return <div>ReadTab</div>;
};

export default ReadTab;
